module.exports = __webpack_public_path__ + "static/media/passengers-icon.bbe00e57.svg";